import i18next from 'i18next';
import _ from 'lodash';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import langInvestWordLang from '../../../apps/investor/langs/langInvestWordLang';
type AppFormatXProps = {
	value?: number | null;
	textIfNull?: string | ReactNode;
	addSpace?: boolean;
	isNS?: boolean;
};
const AppFormatX = (props: AppFormatXProps) => {
	const { value, isNS, textIfNull, addSpace } = props;

	const { t } = useTranslation();

	return (
		<>
			{isNS ? (
				t(langInvestWordLang.ns.tag)
			) : value === undefined ? (
				<>...</>
			) : value === null ? (
				<>{textIfNull ?? '0'}</>
			) : (
				<>
					{_.round(value === 0 ? 0 : value, 2).toLocaleString(i18next.language, {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
					{addSpace ? ' ' : ''}
					<small>x</small>
				</>
			)}
		</>
	);
};

export default AppFormatX;
